<template>
  <div class="pcPersonCenter">
    <el-col class="container" :md="{span: 18, offset: 3}">
      <el-col :md="{span: 24, offset: 0}">
        <div id="sidebar">
          <el-menu
              :default-active="defaultActive"
              class="el-menu-vertical-demo"
              :background-color="theme.bgColor"
              :text-color="theme.textColor"
              :active-text-color="theme.textActiveColor">
            <el-submenu :index="subList.index" v-for="(subList, idx) in sidebarLink" :key="idx">
              <template slot="title">
                <i :class="subList.icon"></i>
                <span>{{ subList.name }}</span>
              </template>
              <el-menu-item  @click="sidebarLinkClick(item.url, item.index)" :index="item.index" v-for="item in subList.list" :key="item.index">
                <span slot="title" class="sidebarLink">{{ item.name }}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div id="view">
          <router-view/>
        </div>
        <div style="clear:both;"></div>
      </el-col>
    </el-col>
  </div>
</template>

<script>
import getUserInfo from "@/assets/js/user/getUserInfo";
import sideBarLinks from "@/pages/userCenter/Mixins/SideBarLinks";

export default {
  name: "pcPersonCenter",
  data() {
    return {
      defaultActive: '1-1',
      sidebarLink: sideBarLinks, //侧边栏数据
      //主题设置
      theme: {
        bgColor: '#ffffff',
        textColor: '#000000',
        textActiveColor: '#ff4a1e',
      },
      userInfo: undefined
    }
  },
  async mounted() {
    let pathList = this.$route.path.split('/')
    let tabPath = '/' + pathList[pathList.length-1];
    let activeItem                                          //为了应对从浏览器地址直接输入url到达指定页面的情况
    for(let i = 0; i < this.sidebarLink.length; i++) {
      activeItem = this.sidebarLink[i].list.find(link => {   //找到sidebarlink里面list的url与当前地址栏url相同的
        return link.url == tabPath
      })
      console.log('eeeeee',activeItem)
      if(activeItem)
        break
    }
    if(!activeItem) {
      activeItem = this.sidebarLink[0].list[0]              //第一次进入个人中心页面，直接进入选项栏第一个
    }
    this.sidebarLinkClick(activeItem.url, activeItem.index)  //路由渲染选中的组件
    this.userInfo = (await getUserInfo()).data.userInfo
  },
  methods: {
    sidebarLinkClick(url, index) {
      this.defaultActive = index
      this.$router.replace({path: '/pages/userCenter/UserCenter' + url})   //刷新路由挂在右侧的选中的组件
    }
  }
}
</script>

<style lang="less">
.pcPersonCenter {
  .container {
    padding: 20px 0;
    #sidebar {
      float: left;
      width: 25%;
    }
    #view {
      float: left;
      margin-left: 2%;
      width: 73%;
    }
    a {
      text-decoration: none;
      color: #7f7f7f;
      &:hover {
        color: #3d5fd5;
      }
    }
  }
}
</style>